import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { PageHeader } from '../../../../Common';
import Joi, { x } from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { BLFactoryWeighSchema } from "../BLFactoryWeighSchema";
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
const screenCode = 'BLFACTORYWEIGHDETAILREPORT'

export function BLFactoryWeighDetailReport(props) {

    const componentRef = useRef();
    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [summeryData, setSummeryData] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "0",
        factoryID: "0",
        collectionPointID: "0",
        toDate: "",
        fromDate: "",
        minimumGrossQuantityID: "0",
        Date: ""
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        operationEntity: "",
        collectionPoint: "",
        date: ""
    });
    const [summeryValues, setSummeryValues] = useState({
        netTot: 0,
        grossTot: 0,
        actualTot: 0,
        bagTot: 0,
        deductTot: 0
    });
    const [contentRowNames, setContentRowNames] = useState(["ftagNumber", "ffullTime", "fstartTime", "count", "factualAmount", "fGrossAmount", "fBag", "fMoisture", "", "fNetAmount"]);
    const pdfRef = React.createRef();
    const [errors, setErrors] = useState({});
    const options = {
        orientation: 'landscape',
        unit: 'in',
        format: [900, 700],
    };
    const schema = Joi.object(BLFactoryWeighSchema).options({ allowUnknown: true });
    const [csvHeaders, setCsvHeaders] = useState([]);
    // const csvHeaders = [
    //     { label: "Tag Number", value: "ftagNumber" },
    //     { label: "Date", value: "ffullTime" },
    //     { label: "Time", value: "fstartTime" },
    //     { label: "Bag Count", value: "count" },
    //     { label: "Actual Amount", value: "factualAmount" },
    //     { label: "Gross Amount", value: "fGrossAmount" }
    // ];

    const [data, setdata] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [searchButtonHide, setSearchButtonHide] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);

    const [bagTotal, setBagTotal] = useState(0);
    const [bagPercentage, setBagPercentage] = useState(0);
    const [deductionTypeNamesOfTable, setDeductionTypeNamesOfTable] = useState([]);

    useEffect(() => {
        trackPromise(
            getPermissions()
        );
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [searchData.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionCategoryForDropDown()
        )
    }, [searchData.factoryID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFACTORYWEIGHDETAILREPORT');
        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });

        trackPromise(
            getGroupsForDropDown()
        );
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
        setOperationEntity(operationEntityList);
    }

    async function getCollectionCategoryForDropDown() {
        const collectionPoint = await service.getCollectionCategoryByOperationEntityForDropDown(searchData.factoryID);
        setCollectionPoint(collectionPoint);
    }


    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;
        const error = { ...errors };
        const errorMessage = validateProperty(target, BLFactoryWeighSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        })
    }



    async function handleSearch(e) {
        e.preventDefault();


        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        let selectedValues = {
            CollectionPointID: parseInt(searchData.collectionPointID),
            Date: searchData.Date

        }
        let result = await service.getReportData(selectedValues);
        var copyOfRsult = _.cloneDeep(result)
        var csvHeaders = [
            { label: "Tag Number", value: "ftagNumber" },
            { label: "Date", value: "ffullTime" },
            { label: "Time", value: "fstartTime" },
            { label: "Bag Count", value: "count" },
            { label: "Actual Amount", value: "factualAmount" },
            { label: "Gross Amount", value: "fGrossAmount" }
        ];
        var result1 = [];
        copyOfRsult.forEach(x => {
            if (result1.length === 0) {
                result1.push(x.fDeductionTypeName);
                csvHeaders.push({ label: x.fDeductionTypeName, value: x.fDeductionTypeName });
            } else {
                var duplicateName = result1.find(y => y === x.fDeductionTypeName);
                if (!duplicateName) {
                    result1.push(x.fDeductionTypeName);
                    csvHeaders.push({ label: x.fDeductionTypeName, value: x.fDeductionTypeName });
                }
            }
        });
        csvHeaders.push({ label: "Net Amount", value: "fNetAmount" });
        setDeductionTypeNamesOfTable(result1);
        let groupedFactoryWeighResult = groupByTag(result);
        let factoryWeighKeys = Object.keys(groupedFactoryWeighResult);
        let factoryWeighArrayCollection = [];
        factoryWeighKeys.forEach(x => {
            var res = pivotFactoryWeighResult(groupedFactoryWeighResult[x]);
            factoryWeighArrayCollection.push(res);
        });

        let bagTot = 0;
        let actualTot = 0;
        let grossTot = 0;
        let netTot = 0;
        let deductTot = [];

        factoryWeighArrayCollection.forEach(x => {
            bagTot = bagTot + x.count;
            actualTot = actualTot + x.factualAmount;
            grossTot = grossTot + x.fGrossAmount;
            netTot = netTot + parseInt(x.fNetAmount);
            result1.forEach(y => {
                if (x[y]) {
                    deductTot.push({
                        property: y,
                        value: checkUndifind(x[y])
                    });

                }
            });
            x.fNetAmount = parseInt(x.fNetAmount);
        });
        const result3 = deductTot.reduce((obj, el) => {

            obj[el.property] = (obj[el.property] || 0) + el.value;

            return obj;
        }, {});

        var resultqqqq = Object.entries(result3);

        var temlArry = [];
        for (const key in resultqqqq) {
            temlArry.push({
                name: resultqqqq[key][0],
                value: resultqqqq[key][1]
            })
        }
        setSummeryData(temlArry);

        setSummeryValues({
            ...summeryValues,
            netTot: netTot,
            grossTot: grossTot,
            actualTot: actualTot,
            bagTot: bagTot,
            deductTot: deductTot
        });
        setCsvHeaders(csvHeaders);
        setdata(factoryWeighArrayCollection);
        setCsvData(factoryWeighArrayCollection);
        setIsTableHide(false);
        setButtonHide(false);
        getSelectedDropdownValuesForReport(searchData);

    }

    function checkUndifind(value) {
        if (value === undefined) {
            return 0;
        }
        else {
            return value;
        }
    }

    const convertFrom24To12Format = (time24) => {
        var timeSplit = time24.split(":");
        return timeSplit[0] + ":" + timeSplit[1];
    }

    function groupByTag(objectArray) {
        return objectArray.reduce(function (acc, obj) {
            let key = obj['tagNumber'] + "-" + obj['startTime'].split("T")[0];

            if (!acc[key]) {
                acc[key] = []
            }
            acc[key].push(obj)
            return acc
        }, {})
    }

    function pivotFactoryWeighResult(data) {
        var result = {};
        data.forEach(function (e) {
            var a = e.tagNumber;

            if (!this[a]) {
                let time = convertFrom24To12Format(e.startTime.split('T')[1].split('.')[0]);

                this[a] = {
                    factualAmount: e.fActualAmount,
                    ftagNumber: e.tagNumber,
                    fstartTime: time,
                    ffullTime: e.startTime.split('T')[0],
                    fNetAmount: e.fNetAmount,
                    fGrossAmount: e.fGrossAmount,
                    count: e.count,
                }
                result = this[a]
            }
            this[a][e.fDeductionTypeName] = e.fTotalDeduction;

        }, {});
        return result;

    }


    function createFile() {
        var settings = {
            sheetName: 'BL Factory Weigh Detail Report',
            fileName: 'BL Factory Weigh Detail Report',
            writeOptions: {}
        }

        var newArray1 = {
            ftagNumber: "Total",
            count: summeryValues.bagTot,
            factualAmount: summeryValues.actualTot,
            fGrossAmount: summeryValues.grossTot,
            fNetAmount: parseInt(summeryValues.netTot)
        }

        summeryData.forEach(x => {
            newArray1[x.name] = x.value;
        });

        var copyOfCsv = _.cloneDeep(csvData)
        var newRow1 = {
            ftagNumber: "Group :" + groups[searchData.groupID],
            ffullTime: "Factory : " + operationEntity[searchData.factoryID],
            fstartTime: "Route : " + collectionPoint[searchData.collectionPointID],
            count: "Date : " + searchData.Date
        }

        copyOfCsv.push(newArray1, {}, {}, newRow1)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            operationEntity: operationEntity[searchForm.factoryID],
            collectionPoint: collectionPoint[searchForm.collectionPointID],
            date: searchForm.Date
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="BL Factory Weigh Detail Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={searchData.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="groupID" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="factoryID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="factoryID"
                                            value={searchData.factoryID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["factoryID"] && <FormHelperText id="factoryID" className="text text-danger">{errors["factoryID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="collectionPointID">Route *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={searchData.collectionPointID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Route--</MenuItem>
                                            {generateDropDownMenu(collectionPoint)}
                                        </Select>
                                        {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <TextField
                                            id="Date"
                                            label="Date *"
                                            name="Date"
                                            type="date"
                                            fullWidth
                                            onChange={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <input
                                            disabled={validate(schema, searchData)}
                                            type="button"
                                            className="btn btn-primary"
                                            value="Generate"
                                            onClick={e => trackPromise(handleSearch(e))}
                                            hidden={searchButtonHide}
                                        />
                                    </div>
                                </div>
                                {data.length == 0 ? null :

                                    <TableContainer component={Paper}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Tag Number</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        Date
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        Time
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        Bag Count
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        Actual Amount
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        Gross Amount
                                                    </TableCell>
                                                    {deductionTypeNamesOfTable.map((item) => (
                                                        <TableCell style={{ fontWeight: "bold" }} align='center'>{item}</TableCell>
                                                    ))}
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        Net Amount
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {data.map((row) => (
                                                    <TableRow key={row.employeeCode}>
                                                        <TableCell component="th" scope="row">
                                                            {row.ftagNumber}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            {row.ffullTime}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            {row.fstartTime}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            {row.count}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            {parseFloat(row.factualAmount).toFixed(2)}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            {parseFloat(row.fGrossAmount).toFixed(2)}
                                                        </TableCell>
                                                        {deductionTypeNamesOfTable.map((column) => {
                                                            const value = row[column];
                                                            return (
                                                                <TableCell align='right'>{value == undefined ? '-' : parseFloat(value).toFixed(2)}</TableCell>
                                                            );
                                                        })}
                                                        <TableCell align="center">{parseInt(row.fNetAmount)}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell colSpan={3} style={{ fontWeight: "bold" }} align="left">
                                                        Total
                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="left">
                                                        {summeryValues.bagTot}
                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="left">
                                                        {parseFloat(summeryValues.actualTot).toFixed(2)}
                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="left">
                                                        {parseFloat(summeryValues.grossTot).toFixed(2)}
                                                    </TableCell>
                                                    {deductionTypeNamesOfTable.map((item) => {
                                                        var result = summeryData.find(y => y.name === item);
                                                        return (
                                                            <TableCell style={{ fontWeight: "bold" }} align='right'>{result == undefined ? parseFloat(0).toFixed(2) : parseFloat(result.value).toFixed(2)}</TableCell>
                                                        );
                                                    })}
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        {parseInt(summeryValues.netTot)}
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }
                                {data.length == 0 ? null :
                                    <div className="pt-2">
                                        <ReactToPrint
                                            documentTitle={"Bl Factory Weigh Detail Report"}
                                            trigger={() => <input
                                                type="button"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                        <div hidden={true}>
                                            <CreatePdf ref={componentRef}
                                                deductionTypeNamesOfTable={deductionTypeNamesOfTable}
                                                data={data}
                                                searchData={selectedSearchValues}
                                                summeryData={summeryData}
                                                summeryValues={summeryValues}
                                            />
                                        </div>
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                    </div>
                                }
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment >
    );
}



